import { useI18n } from "@wato/i18n/react";
import { formatDay, crossesYears } from "../../features/analytics/delivery/delivery-days";
import { isoDayInZone } from "../../lib/analytics-range";

const DAY_MS = 86_400_000;
const PRESET_DAYS: readonly number[] = [7, 30];

/** OWN-371: the period a figure covers, in words. Presets read «آخر ٣٠ يوم»; other ranges «من … إلى …». */
export function periodDays(from: string, to: string, now: Date = new Date()): number | null {
  const start = Date.parse(`${from}T00:00:00Z`);
  const end = Date.parse(`${to}T00:00:00Z`);
  if (Number.isNaN(start) || Number.isNaN(end) || to !== isoDayInZone(now)) return null;
  const days = Math.round((end - start) / DAY_MS) + 1;
  return PRESET_DAYS.includes(days) ? days : null;
}

export function PeriodLabel({
  from,
  to,
  days,
}: {
  readonly from: string;
  readonly to: string;
  /** Known preset length (the page offers 7/30 days directly); skips the "ends today" guess. */
  readonly days?: number;
}) {
  const { t, locale } = useI18n();
  const preset = days ?? periodDays(from, to);
  const withYear = crossesYears([{ day: from }, { day: to }]);
  const text =
    preset !== null
      ? t("analytics.b29b.period.lastDays", { days: preset })
      : t("analytics.b29b.period.range", {
          from: formatDay(from, locale, withYear),
          to: formatDay(to, locale, withYear),
        });
  return (
    <p className="text-sm text-fg-muted" data-testid="analytics-period">
      {text}
    </p>
  );
}
